module.exports = __webpack_public_path__ + "static/media/-_Onboarding.227551fe.png";